import { render, staticRenderFns } from "./phoneSection.vue?vue&type=template&id=3cbeb7f3&scoped=true"
import script from "./phoneSection.vue?vue&type=script&lang=js"
export * from "./phoneSection.vue?vue&type=script&lang=js"
import style0 from "./phoneSection.vue?vue&type=style&index=0&id=3cbeb7f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbeb7f3",
  null
  
)

export default component.exports